import { AuthStatusCode } from "@anydo/interfaces";

export function isAuthStatusCodeError(status: AuthStatusCode): boolean {
  switch (status) {
    case AuthStatusCode.LOGGED_IN:
    case AuthStatusCode.NONE:
    case AuthStatusCode.ABORTED_BY_USER:
    case AuthStatusCode.TWO_FACTOR_REQUIRED:
      return false;

    case AuthStatusCode.FORBIDDEN:
    case AuthStatusCode.INTERNAL_SERVER_ERROR:
    case AuthStatusCode.INVALID_PARAMATER:
    case AuthStatusCode.NETWORK_UNAVAILABLE:
    case AuthStatusCode.THIRD_PARTY_ERROR:
    case AuthStatusCode.UNAUTHORIZED:
    case AuthStatusCode.RATE_LIMIT:
    case AuthStatusCode.UNKNOWN_ERROR:
    case AuthStatusCode.USER_ALREADY_EXIST:
    case AuthStatusCode.LAST_SPACE_ADMIN_REMOVAL:
    case AuthStatusCode.LAST_BOARD_ADMIN_REMOVAL:
    case AuthStatusCode.LAST_GROCERY_BOARD_MEMBER_REMOVAL:
    case AuthStatusCode.CANT_DELETE_PREMIUM_USER:
      return true;
  }
}
